import { render, staticRenderFns } from "./MobileOrderCart.vue?vue&type=template&id=22e9b5a4&"
import script from "./MobileOrderCart.vue?vue&type=script&lang=js&"
export * from "./MobileOrderCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports